/* eslint-disable import/no-anonymous-default-export */
export default {
    temperature: '温度',
    humidity: '湿度',
    air_pressure: '气压',
    co2: '二氧化碳',
    humiture: '温度、湿度',
    pm2510: 'PM2.5、PM10',
    etvoc: 'eTVOC',
    noise: '噪音',
    light: '光照',
}